export default {"src":"https://fishbrain.com/_next/static/media/high.4b864bfe.svg","height":37,"width":46,"blurWidth":0,"blurHeight":0};